<template>
	<div class="container pdet">
		<div class="row">
			<div class="col" style="display: flex; justify-content: space-between; align-items: center;">
				<img :src="path + 'img/pdet-name.png'" alt="" width="400" />
				<img :src="path + 'img/pdet-symbol.png'" alt="" height="80" />
			</div>
		</div>
		<div class="row">
			<div class="col pt-0 pb-3 pl-0" v-for="item of gcontenido_pdet" :key="'a-' + item.idcontenido">
				<texto :id="'txt-' + item.idcontenido" :titulo="item.titulo" :cuerpo="item.descripcion" :enlace="item.enlace" />
			</div>
		</div>
		<div class="row">
			<div class="col text-center pt-0 pb-0 pl-0 mt-4">
				<button type="button" value="Por periodo" class="v-btn theme--light elevation-2 v-size--xlarge secondary w-400" @click="gotoIndiccadorPDET">
					<span class="v-btn__content">Avances indicadores PMI con clasificador PDET</span>
				</button>
			</div>
			<div class="col text-center pt-0 pb-0 pl-0 mt-4">
				<button type="button" value="Por periodo" class="v-btn theme--light elevation-2 v-size--xlarge secondary w-400" @click="gotoIniciativasPDTE">
					<span class="v-btn__content">Avances iniciativas PATR</span>
				</button>
			</div>
		</div>
		<div class="row pt-4" v-if="municipios_todos.length > 0">
			<div class="col pl-0">
				<v-card>
					<v-card-title class="grey lighten-4 d-block text-center" primary-title>
						{{ regiones.length }} Subregiones PDET - {{ municipios_todos.length }} Municipios
					</v-card-title>
				</v-card>
			</div>
		</div>
		<div class="row" v-if="regiones.length > 0">
			<div class="col-7 p-0 pl-0 d-flex align-items-center justify-content-center">
				<div id="chartdiv"></div>
			</div>
			<div class="col pl-0 text-justify">
				<div class="row pb-0">
					<div class="col pb-0">
						<strong>Subregión PDET</strong>
						<hr />
						<v-combobox v-model="region" :items="regiones" label="Seleccione una subregión" @change="regionSelected">
							<template v-slot:item="{ item }">
								<span :style="'background-color: ' + item.color" class="pdet-region-color"> </span>
								<span>{{ item.nombre }}</span>
							</template>
							<template v-slot:selection="data">
								<span :style="'background-color: ' + data.item.color" class="pdet-region-color"> </span>
								<span>{{ data.item.nombre }}</span>
							</template>
						</v-combobox>
						<span v-if="itemSelected">
							<span class="text-semibold"><small>Subregión</small><br />{{ itemSelected.NOM_SUBREG }}</span>
							<hr />
							<span class="text-semibold">Departamentos:</span> {{ itemSelected.NUMERO_DEP }}<br />
							<span class="text-semibold">Municipios:</span> {{ itemSelected.NUMERO_MUN }}<br />
						</span>
					</div>
				</div>
				<div class="row" v-if="municipios.length > 0">
					<div class="col p-0 text-left" v-for="(dpto, index) in departamentos" v-bind:key="index">
						<span class="text-semibold"
							>{{ dpto.nombre }} <small>({{ municipios.filter((o) => o.iddepartamento == dpto.iddepartamento).length }})</small></span
						>
						<hr />
						<span v-for="(item, index) in municipios.filter((o) => o.iddepartamento == dpto.iddepartamento)" v-bind:key="index">
							{{ item.nombre }}<br />
						</span>
					</div>
				</div>
				<div class="row">
					<div class="col p-0">
						<hr />
						<span class="mt-5 d-block"><span class="text-semibold">Fuente:</span> Agencia de Renovación del Territorio ART</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import "@/assets/styles/pdet.scss";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import texto from "@/components/content/texto.vue";
import { mapActions, mapGetters } from "vuex";
am4core.addLicense("MP108998275");

export default {
    components: {
		texto,
	},
	data: () => ({
		regionSerie: null,
		map: null,
		region: null,
		regiones: [],
		departamentos: [],
		departamentos_todos: [],
		municipios: [],
		municipios_todos: [],
		itemSelected: null,
		path: process.env.BASE_URL,
		caja1: {},
	}),
	created() {
        this.getSubregiones({
            params: {
              pdet: true,
              todas: false
            },
        });
        this.getDepartamentos();
        this.getMunicipiospdet({
            params: {
              pdet: true
            },            
        })
		this.textosTodos();
	},
	computed: {
		...mapGetters(["gcontenido_pdet", "gSubregiones", "gDepartamentos", "gMunicipios"]),
	},    
	methods: {
		...mapActions(["getSubregiones", "getDepartamentos", "getMunicipiospdet"]),
		...mapActions(["textosTodos"]),
		gotoIndiccadorPDET()
		{
			// Nota se queman los valores de Punto y clasificador
			// se llama ese formulario desde aqui con esos valores predeterminados y no va a cambiar.
			let link = "/avance/clasificacionpdte/1/4"; 
      		this.$router.push(link);
		},
		gotoIniciativasPDTE(){
			let link = "/iniciativas"; 
      		this.$router.push(link);
		},
		set_region(region_id) {
			this.regionSelected(this.get_region({ COD_SUBREG: region_id }));
		},
		get_region(data) {
			let item = this.gSubregiones.find((o) => o.idsubregion == data.COD_SUBREG);
			return typeof item !== "undefined" ? item : null;
		},
		regionSelected(e) {
			this.region = e;
			let reg = this.regionSerie.getPolygonById(e.idsubregion);
			reg.isHover = true;
			this.itemSelected = reg.dataItem.dataContext;
			this.municipios = this.municipios_todos.filter((o) => o.idsubregion == this.region.idsubregion);
			const dpto_ids = [...new Set(this.municipios.map((item) => item.iddepartamento))];
			this.departamentos = this.departamentos_todos.filter((o) => dpto_ids.includes(o.iddepartamento));
		},
		makeChart() {
			var chart = am4core.create("chartdiv", am4maps.MapChart);

			// Set projection
			chart.projection = new am4maps.projections.Miller();
			chart.seriesContainer.draggable = false;
			chart.seriesContainer.resizable = false;
			chart.maxZoomLevel = 1;

			// Dptos
			let dptoSerie = chart.series.push(new am4maps.MapPolygonSeries());
			
			dptoSerie.geodataSource.url = this.path + "geo/dpto1.json";
			dptoSerie.reverseGeodata = true;
			let polygonTemplate = dptoSerie.mapPolygons.template;
			// polygonTemplate.tooltipText = "{DPTO_CNMBR} ({DPTO_CCDGO})";
			polygonTemplate.fill = am4core.color("#eeeeee");
			polygonTemplate.stroke = am4core.color("#999999");
			polygonTemplate.strokeWidth = 1;
			polygonTemplate.nonScalingStroke = true;

			// San Andrés
			let saSerie = chart.series.push(new am4maps.MapPolygonSeries());
			saSerie.geodataSource.url = this.path + "geo/dpto-sa.json";
			saSerie.useGeodata = true;
			saSerie.mapPolygons.template = polygonTemplate;			

			// https://www.amcharts.com/docs/v4/reference/mappolygonseries/
			this.regionSerie = chart.series.push(new am4maps.MapPolygonSeries());
			this.regionSerie.calculateVisualCenter = true;
			// regionSerie.mapPolygons.template.showTooltipOn = "always";
			this.regionSerie.mapPolygons.template.tooltipPosition = "fixed";
			this.regionSerie.geodataSource.url = this.path + "geo/reg.json";
			this.regionSerie.reverseGeodata = true;
			// https://www.amcharts.com/docs/v4/reference/mappolygon/#Properties
			let regPolygonTemplate = this.regionSerie.mapPolygons.template;
			regPolygonTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;
			regPolygonTemplate.tooltipText = "Subregión:\n{NOM_SUBREG}";
			regPolygonTemplate.fillOpacity = 0.8;
			regPolygonTemplate.stroke = am4core.color("#666666");
			regPolygonTemplate.strokeWidth = 0;
			regPolygonTemplate.nonScalingStroke = true;
			regPolygonTemplate.adapter.add("fill", (fill, target) => {
				if (typeof target.dataItem.dataContext !== "undefined") {
					let reg = this.get_region(target.dataItem.dataContext);
					return reg.color;
				}
			});
			regPolygonTemplate.events.on("hit", (ev) => {
				this.regionSelected(this.get_region(ev.target.dataItem.dataContext));
			});

			// Hover state
			let hs = regPolygonTemplate.states.create("hover");
			hs.properties.fillOpacity = 1;

			//chart.zoomControl = new am4maps.ZoomControl();
			// chart.events.on("beforedatavalidated", function(ev) {
			// 	console.log("ev.target.data =>", ev.target.data);
			// });
			this.map = chart;

			// Establece la región seleccionada
			setTimeout(() => {
				this.set_region(12);
			}, 800);
		},
	},
	mounted() {
	},
	beforeDestroy() {
		if (this.map) {
			this.map.dispose();
		}
	},
	watch: {
        gSubregiones: function() {
            this.regiones = this.gSubregiones;
        },
        gDepartamentos: function () {
            this.departamentos_todos = this.gDepartamentos;
        },
        gMunicipios: function () {
            this.municipios_todos = this.gMunicipios;
            if (this.municipios_todos.length > 0)
				this.makeChart();	
        }
    },
};
</script>
<style scoped>
#chartdiv {
	width: 100%;
	height: 800px;
}
</style>
